import { render } from "./EventsListTable.vue?vue&type=template&id=45a00a90"
import script from "./EventsListTable.vue?vue&type=script&lang=js"
export * from "./EventsListTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src973090976/src/remoterespects-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__